var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isCatalogActive)?_c('a',{staticClass:"expo-btn expo-btn-white",attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('b-icon-book-half')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }